import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";

const firstName = (c) => c.first_name || (c.name || "").split(" ")[0] || "";

const buildMessage = (c, items) => [
  `Ciao ${firstName(c)}!`.replace(" !", "!"),
  "Ho controllato le tue misure e questi capi ti starebbero proprio bene:",
  "",
  ...items.map((p) => `• ${p.name} – taglia ${p.size}${p.available ? ` (disponibile in ${p.colors.map((x) => x.color).join(", ")})` : ""}`),
  "",
  "Se vuoi te li metto da parte o ti mando altre foto. Fammi sapere!",
].join("\n");

const waNumber = (phone) => {
  const d = (phone || "").replace(/[^\d+]/g, "").replace(/^00/, "+");
  if (!d) return null;
  return (d.startsWith("+") ? d.slice(1) : d.length === 10 ? `39${d}` : d);
};

export const ProposalDialog = ({ customer, items, onClose }) => {
  const qc = useQueryClient();
  const [text, setText] = useState(() => buildMessage(customer, items));
  const wa = waNumber(customer.phone);
  const record = async (channel) => {
    try {
      await api.post(`/customers/${customer.id}/proposals`, {
        channel, message: text, items: items.map((p) => ({ name: p.name, size: p.size, colors: p.colors.map((c) => c.color) })),
      });
      qc.invalidateQueries({ queryKey: ["proposals", customer.id] });
      toast.success("Proposta registrata: vedrai se la cliente acquista");
      onClose(true);
    } catch (e) { toast.error(e?.response?.data?.detail || "Registrazione non riuscita"); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); toast.success("Testo copiato"); } catch { toast.error("Copia non riuscita: seleziona il testo a mano"); }
    record("copia");
  };
  const whatsapp = () => {
    window.open(`https://wa.me/${wa}?text=${encodeURIComponent(text)}`, "_blank", "noopener");
    record("whatsapp");
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose(false)}>
      <DialogContent data-testid="proposal-dialog">
        <DialogHeader>
          <DialogTitle>Messaggio per {customer.name}</DialogTitle>
          <DialogDescription>Puoi modificare il testo prima di inviarlo. La proposta viene registrata così vedi se la cliente acquista nei 30 giorni successivi.</DialogDescription>
        </DialogHeader>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={10} data-testid="proposal-text" />
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={copy} data-testid="proposal-copy"><Copy className="mr-2 h-4 w-4" />Copia testo</Button>
          {wa && <Button onClick={whatsapp} className="bg-emerald-600 hover:bg-emerald-700" data-testid="proposal-whatsapp"><MessageCircle className="mr-2 h-4 w-4" />Apri WhatsApp</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
